// src/i18n/en/hotelsOverview.ts
// «Instalaciones» (mockup 09, formerly «Hoteles») — route /hotels-overview, Dirección.
export const hotelsOverview = {
  name: 'Properties |||| Properties',
  subtitle: "How each of the group's properties resolves its arrivals",

  onlyWithArrivals: 'Only with arrivals',

  table: {
    columns: {
      hotel: 'Property',
      arrivalsPerDay: 'Arrivals per day',
      arrivals: 'Arrivals',
      preCheckInDonePct: '% pre-check-in',
      resolvedWithoutReceptionPct: '% self-service',
      kioskCheckIns: 'Kiosk or phone check-ins',
      medianKioskSeconds: 'Median duration',
      leftMidwayPct: '% left midway at kiosk or phone',
      charged: 'Charged',
    },
  },

  source: {
    hotelSystem: "Arrivals from the hotel's reservation list",
    roommatik: 'Reservations with Roommatik activity',
  },

  chainAverage: 'Average of the hotels',

  chartDialog: {
    openAria: 'Enlarge the arrivals-per-day chart of %{name}',
    title: 'Arrivals per day · %{name}',
    period: 'From %{from} to %{to}',
    total: 'Period total: %{count} arrival |||| Period total: %{count} arrivals',
    close: 'Close',
  },

  equipment: {
    kiosk: 'Kiosk',
    airLobby: 'Air Lobby',
    online: 'Online',
  },

  help: {
    title: 'Properties',
    description: 'Compare how each property resolves its arrivals: pre-check-in, self-service and guests who leave midway.',
    features: {
      sparkline: 'The "Arrivals per day" column shows the period\'s trend in miniature; click it to enlarge.',
      onlyWithArrivals: 'Turn on "Only with arrivals" to hide properties with no activity in the period.',
      source:
        "Under each property's name you can see where its arrivals come from: the hotel's reservation list (without cancelled and no-show) or, if it does not share it, the reservations with Roommatik activity. The row's percentages are over those arrivals.",
      kiosk: "The kiosk columns include check-in on the phone, which is the same journey on the guest's own phone. They have a figure when the property has a registered kiosk or check-ins at the kiosk or on the phone in the period.",
    },
    tips: {
      dash: 'A "—" cell means the figure cannot be computed: the property has no such equipment or had no arrivals in the period. A zero is shown as 0.',
    },
  },
};

export default hotelsOverview;
